import gql from 'graphql-tag'

const AllTaskTypes = gql`
  query AllTaskTypes {
    allTaskTypes {
      id
      name
      description
    }
  }
`

const AllTaskStates = gql`
  query AllTaskStates {
    allTaskStates
  }
`

const AllTaskPriorities = gql`
  query AllTaskPriorities {
    allTaskPriorities
  }
`

export { AllTaskTypes, AllTaskStates, AllTaskPriorities }


// WEBPACK FOOTER //
// ./src/queries/AllTaskProperties.js